import { useEffect, useState } from "react";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { useMe } from "@signet/web-kit";
import { ItemsPanel } from "./items.tsx";
import { SpendPanel } from "./spend.tsx";
import { UPCOMING_ID, UpcomingPanel } from "./upcoming.tsx";

/* ──────────────────────────────────────────────────────────────────────────
   Expiries (Jay, 2026-10-21), top to bottom: the total spent each month with
   its History, what runs out in the next week with Mark as Paid, then every
   line item. Now's Open button arrives with ?focus=upcoming, which scrolls
   to the middle box and lights it up for a moment.
   ────────────────────────────────────────────────────────────────────────── */

export function ExpiriesPage() {
  const { can } = useMe();
  const search = useSearch({ strict: false } as never) as { focus?: string };
  const navigate = useNavigate();
  const [flash, setFlash] = useState(false);

  useEffect(() => {
    if (search.focus !== "upcoming") return;
    document.getElementById(UPCOMING_ID)?.scrollIntoView({ behavior: "smooth", block: "center" });
    setFlash(true);
    navigate({ to: ".", search: {} as never, replace: true });
    const timer = setTimeout(() => setFlash(false), 1600);
    return () => clearTimeout(timer);
  }, [search.focus, navigate]);

  return (
    <div className="page ex-page">
      <header className="page-head">
        <div>
          <h1>Expiries</h1>
          <p>What the agency pays for again and again, and when each one runs out next.</p>
        </div>
      </header>
      {can("expiries.payment:view") ? <SpendPanel /> : null}
      <UpcomingPanel flash={flash} />
      <ItemsPanel />
    </div>
  );
}
